<template>
  <div>
    <h1>
      Add Contract
      <span v-if="specs.name && specs.url"
        >for {{ specs.name }}({{ specs.url }})</span
      >
    </h1>
    <hr />
    <br />
    <span v-if="!$route.params.channelId"
      ><h3>What contract would you like to add?</h3>
      <p>
        <MultiTags
          v-if="!this.$route.params.channelId"
          v-model="dropdownSelectedChannel"
          placeholder="Start typing a job board name..."
          main_name_key="name"
          secondary_name_key="type"
          :autocomplete-endpoint="channelsDropdownEndpoint"
          search-param="search"
          :max-tags="1"
          @input="initChannelData"
        ></MultiTags>
      </p>
    </span>
    <vue-json-pretty
      :data="error"
      v-if="Object.keys(error).length"
      :deepCollapseChildren="true"
    ></vue-json-pretty>
    <b-alert :show="error.length" variant="warning">
      <v-icon small color="white">fas fa-exclamation-triangle</v-icon>
      {{ error }}
    </b-alert>
    <div v-if="selectedChannelId" class="col-sm-12 col-lg-6 col-xxl-4 p-0 mb-4">
      <h3>Contract Group</h3>
      <b-form-select
        v-model="selectedGroupId"
        :options="groupSelectOptions"
        required
      ></b-form-select>
    </div>
    <div
      v-if="selectedGroupId === 'add-new-group'"
      class="col-sm-12 col-lg-6 col-xxl-4 p-0 mt-4 mb-4"
    >
      <label class="w-100">
        Group Name
        <b-form-input id="new-contract-group-name" v-model="newGroupName">
        </b-form-input>
        <b-alert
          :show="newGroupError.trim() !== ''"
          variant="warning"
          class="mt-4"
        >
          <v-icon small color="white">fas fa-exclamation-triangle</v-icon>
          {{ newGroupError }}
        </b-alert>
        <b-button
          class="mt-8"
          @click="addGroup"
          :disabled="isSavingNewGroup"
          variant="secondary"
          small
          >Create Group</b-button
        >
      </label>
    </div>
    <span v-if="specs.manual_setup_required">
      <h3>Instructions</h3>
      <span v-html="specs.setup_instructions"> </span>
      <span v-if="specs.feed_url">
        <p>
          <b-form-input
            id="input-large"
            ref="feed_url"
            size="lg"
            v-model="specs.feed_url"
            v-on:focus="$event.target.select()"
            readonly
          >
          </b-form-input>
        </p>
        <p>
          <b-button @click="copyToClipboard" variant="secondary" small
            ><v-icon>mdi-content-copy</v-icon> Copy URL!</b-button
          >
        </p>
      </span>
      <p v-if="specs.manual_setup_required">
        <label
          ><b-form-checkbox
            size="lg"
            inline
            v-model="contract.followed_instructions"
          />I understand that my contract can only be activated if I follow the
          instructons
        </label>
      </p>
    </span>
    <span v-if="specs.contract_credentials && specs.contract_credentials.length"
      ><h3>Credentials</h3>
      <div
        class="contract-input"
        v-for="credential in specs.contract_credentials"
        v-bind:key="credential.name"
      >
        <template v-if="credential.url">
          <p>
            {{ credential.label }}
            <v-icon
              v-if="credential.description"
              v-b-tooltip.hover
              :title="credential.description"
              small
              color="gray"
              >fas fa-question-circle
            </v-icon>
          </p>
          <p>
            <b-alert v-if="contract.credentials[credential.name]" show
              >You are authenticated with {{ specs.name }}.</b-alert
            >
            <b-link v-else :href="oauthInitUrl" class="btn btn-success"
              >Initialize authentication</b-link
            >
          </p>
        </template>
        <template v-else>
          <p>
            {{ credential.label }}
            <v-icon
              v-if="credential.description"
              v-b-tooltip.hover
              :title="credential.description"
              small
              color="gray"
              >fas fa-question-circle
            </v-icon>
          </p>
          <p>
            <b-form-input
              v-model="contract.credentials[credential.name]"
              :placeholder="credential.label"
            ></b-form-input>
          </p>
        </template>
      </div>
      <br
    /></span>
    <br />

    <span v-if="specs.facets">
      <h3>Contract options</h3>
      <FacetsForm
        :channel-id="specs.channelId"
        :facets="specs.facets"
        v-model="contract.facets"
      ></FacetsForm>
    </span>
    <br />
    <span v-if="Object.keys(specs).length">
      <hr />
      <h3>Optional details</h3>
      <p></p>
      <div class="row mb-4">
        <div class="col-md-2">Contract alias</div>
        <div class="col-md-4">
          <b-input
            type="text"
            placeholder="Contract Alias"
            v-model="contract.alias"
          ></b-input>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-2">
          Posting Duration (days)
          <u
            title="Optional number of days after which the job posted will expire"
            >?</u
          >
        </div>
        <div class="col-md-4">
          <b-input
            type="number"
            placeholder="Posting Duration"
            v-model="contract.posting_duration_days"
          ></b-input>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-2">Contract expiry</div>
        <div class="col-md-4">
          <b-form-datepicker
            value-as-date
            v-model="contract.expiry_date"
          ></b-form-datepicker>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-2">Purchase Price</div>
        <div class="col-md-3">
          <b-input
            type="number"
            placeholder="Amount"
            v-model="contract.purchase_price.amount"
          ></b-input>
        </div>
        <div class="col-md-1">
          <b-input
            type="text"
            placeholder="currency"
            max-length="3"
            length="3"
            class="md-9"
            v-model="contract.purchase_price.currency"
          ></b-input>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-2">How many credits?</div>
        <div class="col-md-3">
          <b-input
            type="number"
            placeholder="number of credits"
            v-model="contract.credits"
          ></b-input>
        </div>
      </div>
      <p>
        <label>
          <b-form-checkbox inline size="lg" />
          Allow for re-negotiation when contract expires</label
        >
      </p>
      <p>
        <b-button
          v-on:click="addContract"
          class="full-width"
          href="#"
          variant="primary"
          :disabled="!isValid"
          >Add to my contract
        </b-button>
      </p>
    </span>
  </div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import { HapiService } from "@/core/services/hapi.service";
import FacetsForm from "@/view/content/forms/FacetsForm";
import MultiTags from "@/view/content/forms/MultiTags";

export default {
  name: "AddContract",
  components: { MultiTags, FacetsForm, VueJsonPretty },
  data() {
    return {
      selectedChannelId: null,
      dropdownSelectedChannel: null,
      channelsDropdownEndpoint: "products/channels/mocs/",
      specs: {},
      error: {},
      contract: {
        credentials: {},
        facets: {},
        expiry_date: null,
        posting_duration_days: null,
        alias: null,
        purchase_price: {},
        credits: null,
        followed_instructions: null
      },
      groups: [],
      selectedGroupId: undefined,
      newGroupName: "",
      newGroupError: "",
      isSavingNewGroup: false
    };
  },
  computed: {
    groupSelectOptions() {
      const addNewGroupOption = {
        text: "Add new group",
        value: "add-new-group"
      };
      return [
        ...this.groups.map(group => ({ text: group.name, value: group.id })),
        addNewGroupOption
      ];
    },
    oauthCredential() {
      return this.specs?.contract_credentials?.find(credential => {
        return !!credential.url && credential.name != "feed-random";
      });
    },
    oauthInitUrl() {
      const credential = this.oauthCredential;
      if (credential) {
        const callbackUrl = encodeURIComponent(
          `${process.env.VUE_APP_BASE_URL}/contracts/add/${this.specs.id}/`
        );
        return `${credential.url}&callbackUrl=${callbackUrl}`;
      }
      return null;
    },
    isValid() {
      return !this.specs?.contract_credentials?.some(
        credential => !this.contract.credentials[credential.name]
      );
    }
  },
  methods: {
    async addGroup() {
      try {
        this.newGroupError = "";
        this.isSavingNewGroup = true;
        const { data } = await HapiService.createContractGroup({
          name: this.newGroupName
        });
        this.groups.push(data);
        this.selectedGroupId = data.id;
        this.$bvToast.toast(
          `Contract group created successfully for ${this.newGroupName}`,
          {
            variant: "success",
            solid: true
          }
        );
        this.newGroupName = "";
      } catch (error) {
        if (error?.response?.data && error?.response?.data?.name) {
          this.newGroupError = "Group name is already in use";
        }
      } finally {
        this.isSavingNewGroup = false;
      }
    },
    async addContract() {
      const response = await HapiService.addContract(
        this.$auth.user.sub,
        this.specs.id,
        this.contract.credentials,
        this.contract.facets,
        this.contract.followed_instructions,
        this.contract.expiry_date,
        this.contract.purchase_price.amount,
        this.contract.purchase_price.currency,
        this.contract.credits,
        this.contract.alias,
        this.selectedGroupId,
        this.contract.posting_duration_days
      );
      if (response.status === 201) {
        this.$bvToast.toast(
          `Contract created successfully for ${this.specs.name}`,
          {
            variant: "success",
            solid: true
          }
        );
        await this.$router.push({ name: "list-contract" });
      } else {
        this.error = response.data;
      }
    },
    copyToClipboard() {
      this.$refs.feed_url.focus();
      document.execCommand("copy");
      this.$bvToast.toast("URL Copied to clipboard.");
    },
    async initChannelData(channelId) {
      this.selectedChannelId = Array.isArray(channelId)
        ? channelId[0]
        : channelId;
      const response = await HapiService.retrieveChannelMoc(
        this.selectedChannelId
      );
      this.specs = response.data;
    },
    async handleOauthData() {
      const credential = this.oauthCredential;
      if (credential) {
        // IGB is supposed to return a redirect url containing the param named as the credential.name
        // const credentialValue = credential.name
        const credentialValue = this.$route.query?.hash;
        if (credentialValue) {
          this.contract.credentials = {
            [credential.name]: credentialValue
          };
        }
      }
    }
  },

  async mounted() {
    const { data: groups } = await HapiService.listContractGroups();
    this.groups = groups;
    this.selectedGroupId = groups[0].id;
    if (this.$route.params.channelId) {
      await this.initChannelData(this.$route.params.channelId);
    }
    this.handleOauthData();
  }
};
</script>

<style scoped></style>
